import React, { FC } from 'react';
import ucWords from '../../../utils/ucWords';

interface WarningsProps {
  warnings: any;
}

const renderParameter = (value: any) => {
  if (value === null || value === undefined) return 'N/A';
  if (typeof value !== 'object') return String(value);

  const entries = Object.entries(value);
  const regex = /(id|name|date)/i;

  const displayEntries = entries.filter(([k]) => regex.test(k));

  return (
    <div className="flex flex-col whitespace-pre-wrap">
      {displayEntries.map(([k, v]) => (
        <div key={k}>
          <strong>{k}:</strong> {String(v)}
        </div>
      ))}
    </div>
  );
};

const renderTable = (array: any) => {
  if (array.length === 0) return '';
  const parameterKeys = array[0].meta?.parameters
    ? Object.keys(array[0].meta.parameters).filter((key) => key !== 'query')
    : [];

  const headers = ['message', ...parameterKeys.map((key, index) => (/^\d+$/.test(key) ? `object ${index + 1}` : key))];

  return (
    <div className="mb-8 overflow-x-auto">
      <table className="min-w-full table-auto border-collapse">
        <thead>
          <tr>
            {headers.map((header) => (
              <th key={header} className="border border-gray-300 px-4 py-2 bg-gray-100 text-left">
                {ucWords(header)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {array.map((item: any, index: number) => (
            <tr key={index}>
              <td className="border border-gray-300 px-4 py-2 whitespace-nowrap align-top">{item.message}</td>
              {parameterKeys.map((key) => (
                <td key={key} className="border border-gray-300 px-4 py-2 whitespace-nowrap align-top">
                  {renderParameter(item.meta?.parameters?.[key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const Warnings: FC<WarningsProps> = ({ warnings }) => {
  return (
    <div className="rounded-lg w-full overflow-hidden overflow-y-auto scrollbar" data-testid="warnings">
      {Object.entries(warnings).map(([header, typedWarnings]: any) => {
        return (
          <details className="p-4" key={header} open>
            <summary className="text-xl mb-4">{ucWords(header)}</summary>
            {renderTable(typedWarnings)}
          </details>
        );
      })}
    </div>
  );
};
